import { useMemo, useState } from "react";
import { useQuery } from "react-query";
import { useSelector } from "react-redux";
import userimage from "../../pics/LeaderUserIcon.png";
import Starsicon from "../../pics/LeaderBoardStarsIcon.png";
import postion1 from "../../pics/Position1Icon.png";
import postion2 from "../../pics/Position2Icon.png";
import postion3 from "../../pics/Position3Icon.png";
import apisecured from "../../api/apisecured";

export default function ColorLeaderBoard() {
  const creatorUser = useSelector((state) => state.userProfile);
  const [activeTab, setActiveTab] = useState("all");

  const tabs = [
    { id: "week", label: "Week" },
    { id: "month", label: "Month" },
    { id: "all", label: "All Time" },
    { id: "recent", label: "Recent" },
  ];

  const { data, isLoading, isError } = useQuery(
    ["creator_leaderboard", creatorUser?.userName],
    async () => {
      const username = encodeURIComponent(creatorUser.userName);

      const res = await apisecured.get(
        `goals/get_creator_leaderboard?username=${username}`,
      );

      return res.data;
    },
    {
      enabled: !!creatorUser?.userName,
      refetchOnWindowFocus: false,
    },
  );

  const normalizeLeaderboard = (items = []) => {
    if (!Array.isArray(items)) return [];

    return items.map((item, index) => ({
      id:
        item.id ||
        item._id ||
        item.tipId ||
        item.userId ||
        `${item.name || "unknown"}-${item.amount || 0}-${item.date || ""}-${index}`,
      name: item.name || "Unknown",
      amount: item.amount || 0,
      date: item.date || null,
    }));
  };

  const leaderboardData = useMemo(
    () => ({
      week: normalizeLeaderboard(data?.weekly),
      month: normalizeLeaderboard(data?.monthly),
      all: normalizeLeaderboard(data?.allTime),
      recent: normalizeLeaderboard(data?.recent),
    }),
    [data],
  );

  const activeUsers = leaderboardData[activeTab] || [];

  const currencySymbols = {
    usd: "$",
    gbp: "£",
    eur: "€",
  };

  const formatAmount = (amount) => {
    const symbol = currencySymbols[creatorUser?.currency?.toLowerCase()] || "$";
    const numericAmount = Number(amount);

    if (Number.isNaN(numericAmount)) return `${symbol}0`;

    return `${symbol}${numericAmount.toLocaleString(undefined, {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    })}`;
  };

  return (
    <div className="w-full bg-[linear-gradient(180deg,_#030021_0%,_#4C34B1_50%)] rounded-[20px] border-[1px] border-solid border-[rgba(53,52,74,1)] overflow-hidden !md:p-3 !p-2">
      <div className="relative py-2 px-2 md:py-4 md:px-4 text-center">
        <div className="flex justify-center items-center gap-1 md:gap-3">
          <img
            src={Starsicon}
            alt=""
            className="w-10 h-14 md:w-[32px] lg:w-[48px] md:h-[42px] lg:h-[62px]"
          />

          <div className="space-y-0.5">
            <h1 className="text-white font-bold text-[16px] sm:text-[20px] md:text-[26px] lg:text-[32px] leading-[100%] tracking-[0%] text-center">
              TOP TIPS
            </h1>

            <h1 className="text-white font-bold text-[15px] sm:text-[20px] md:text-[24px] leading-[100%] tracking-[0%] text-center">
              LEADERBOARD
            </h1>
          </div>

          <img
            src={Starsicon}
            alt=""
            className="w-10 h-14 md:w-[32px] lg:w-[48px] md:h-[42px] lg:h-[62px]"
          />
        </div>

        <div className="flex justify-between mt-2 md:mt-4 mx-auto lg:px-6 md:px-4 px-2">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              type="button"
              className={`py-1 px-1 transition-all duration-300 font-bold text-[12px] sm:text-[14px] md:text-[16px] lg:text-[19px] leading-[100%] tracking-[0%] text-center text-white ${
                activeTab === tab.id
                  ? "font-bold border-b-2 border-[#00FF8F]"
                  : "hover:text-gray-200"
              }`}
              onClick={() => setActiveTab(tab.id)}
            >
              {tab.label}
            </button>
          ))}
        </div>
      </div>

      <div className="max-h-96 px-2 overflow-y-auto custom-colorfull-scrollbar space-y-1.5">
        {isLoading && (
          <div className="p-4 text-white text-sm">Loading leaderboard...</div>
        )}

        {isError && (
          <div className="p-4 text-red-500 text-sm">
            Failed to load leaderboard data.
          </div>
        )}

        {!isLoading &&
          !isError &&
          activeUsers.map((user, index) => {
            const isTopRank = index < 3 && activeTab !== "recent";

            return (
              <div
                key={`${activeTab}-${user.id}`}
                className={`flex items-center justify-between sm:px-6 px-3 xl:px-6 md:px-4 py-2 rounded-[20px] ${
                  isTopRank
                    ? "bg-[linear-gradient(90deg,_#00FF8F_0%,_#33B4FF_100%)] text-[#000000]"
                    : "bg-[#030021] !text-white"
                } border-b border-indigo-800`}
              >
                <div className="flex items-center gap-1 sm:gap-2 lg:gap-4 min-w-0">
                  {isTopRank ? (
                    <img
                      src={
                        index === 0
                          ? postion1
                          : index === 1
                            ? postion2
                            : postion3
                      }
                      alt=""
                      className="w-[26px] h-[28px] sm:w-8 sm:h-10 lg:w-[30px] lg:h-[35px]"
                    />
                  ) : (
                    <div className="w-[26px] h-[28px] sm:w-8 sm:h-10 lg:w-[30px] lg:h-[35px]" />
                  )}

                  <img
                    src={userimage}
                    alt=""
                    className="w-10 h-10 sm:w-12 sm:h-12 lg:w-[44px] lg:h-[44px] lg:ml-1"
                  />

                  <div className="min-w-0">
                    <span className="block font-bold text-[14px] sm:text-[16px] md:text-[18px] lg:text-[20px] leading-[100%] tracking-[0%] truncate max-w-[100px] sm:max-w-[120px] md:max-w-full">
                      {user.name}
                    </span>

                    {activeTab === "recent" && user.date && (
                      <span className="block text-[10px] sm:text-[12px] opacity-80 mt-1 truncate">
                        {user.date}
                      </span>
                    )}
                  </div>
                </div>

                <div className="font-bold text-[14px] sm:text-[16px] md:text-[18px] lg:text-[20px] leading-[100%] tracking-[0%] whitespace-nowrap">
                  {formatAmount(user.amount)}
                </div>
              </div>
            );
          })}

        {!isLoading && !isError && activeUsers.length === 0 && (
          <div className="p-4 md:p-6 text-center text-white text-sm md:text-base">
            No data available for this time period
          </div>
        )}
      </div>
    </div>
  );
}
